import { PDFViewer, Document } from "@react-pdf/renderer";
import { IRecibos } from "src/Contexts/Recibos/RecibosTypes";
import { Children } from "react";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { TableBase } from "src/Pages/components/PDF/TableBase";
import { PDFCabeçalho } from "src/Pages/components/PDF/Cabeçalho";
import { PageCorePDF } from "src/Pages/components/PDF/PageCorePDF";
import { TableRowContainer } from "src/Pages/components/PDF/TableRowContainer";
import { PDFTableRow } from "src/Pages/components/PDF/TableRow";
import { FormatMoney } from "src/shared/Utils/FormatMoney";

import { Box, LinearProgress } from "@mui/material";
import { HeadPDFResumeConfirmationReceipt } from "./HeadPDFResumeConfirmationReceipt";

interface IConfirmationReceipt {
  nomeEmpresa?: string | undefined;
  isLoading: boolean;
  listRecibos: IRecibos | undefined;
  setListRecibos: React.Dispatch<React.SetStateAction<IRecibos | undefined>>;
  title: string;
}

export const ResumoPDF = ({
  isLoading,
  nomeEmpresa,
  listRecibos,
  title,
}: IConfirmationReceipt) => {
  const payments = listRecibos?.payments;

  return (
    <>
      {nomeEmpresa && !!payments?.length && listRecibos?.payments?.length && (
        <PDFViewer style={{ height: "84vh" }} width="100%">
          <Document
            creator="Brokeris"
            title={
              listRecibos.meta.typePayments === "ALL"
                ? title
                : `${listRecibos?.payments[0].codeProdutor} - ${
                    listRecibos?.payments[0].produtor
                  } - ${FormatDateBR(
                    listRecibos.payments[0].dateCurrency.date
                  )}`
            }
          >
            <PageCorePDF orientation="landscape">
              <PDFCabeçalho
                dateCurrency={FormatDateBR(
                  listRecibos.payments[0].dateCurrency.date
                )}
                empresa=""
                endDate={FormatDateBR(
                  listRecibos.payments[0].resume.dataPayments.endDate
                )}
                hoursCurrency={listRecibos.payments[0].dateCurrency.hours}
                nomePdf="Resumo de pagamento"
                startDate={FormatDateBR(
                  listRecibos.payments[0].resume.dataPayments.startDate
                )}
              />

              <TableBase>
                <HeadPDFResumeConfirmationReceipt />

                {Children.toArray(
                  listRecibos.payments.map((item) => {
                    return (
                      <TableRowContainer>
                        <PDFTableRow
                          title={`${item.codeProdutor} - ${item.produtor}`}
                          width="17%"
                          textAlign="left"
                          paddingLeft="8px"
                          key={"Produtor"}
                        />
                        <PDFTableRow
                          textAlign="right"
                          width="12%"
                          title={`R$ ${FormatMoney(
                            item.parcelas
                              .reduce(
                                (acc, item) =>
                                  acc + Number(item.parcela.valorPagar),
                                0
                              )
                              .toFixed(2)
                          )}`}
                          key={"Valor Comissão"}
                        />
                        <PDFTableRow
                          title={
                            item.resume.totalContaCorrente < 0
                              ? `R$ -${FormatMoney(
                                  item.resume.totalContaCorrente?.toFixed(2)
                                )}`
                              : `R$ ${FormatMoney(
                                  item.resume.totalContaCorrente?.toFixed(2)
                                )}`
                          }
                          width="14%"
                          textAlign="right"
                          key={"Conta corrente atual"}
                        />
                        <PDFTableRow
                          title={
                            item.resume.totalAReceber < 0
                              ? `R$ ${FormatMoney("0.00")}`
                              : `R$ ${FormatMoney(
                                  item.resume.totalAReceber?.toFixed(2)
                                )}`
                          }
                          width="12%"
                          textAlign="right"
                          key={"Valor a pagar"}
                        />
                        <PDFTableRow
                          title={
                            item.resume.totalAReceber < 0
                              ? `R$ -${FormatMoney(
                                  item.resume.totalAReceber?.toFixed(2)
                                )}`
                              : `R$ ${FormatMoney("0.00")}`
                          }
                          width="15%"
                          textAlign="right"
                          paddingRight="8px"
                          borderRight="1px solid #292929"
                          key={"Conta corrente restante"}
                        />

                        <PDFTableRow
                          title={item.contaBancaria.banco.value}
                          width="5%"
                          textAlign="right"
                        />
                        <PDFTableRow
                          title={item.contaBancaria.agencia}
                          width="6%"
                          textAlign="right"
                          key={"Banco"}
                        />
                        <PDFTableRow
                          title={item.contaBancaria.conta}
                          width="8%"
                          textAlign="right"
                          key={"Agência"}
                        />
                        <PDFTableRow
                          title={item.contaBancaria.pix}
                          width="11%"
                          textAlign="right"
                          paddingRight="8px"
                          key={"Pix"}
                        />
                      </TableRowContainer>
                    );
                  })
                )}
                <TableRowContainer backgroundColor="#e6e6e6">
                  <PDFTableRow
                    paddingLeft="8px"
                    title={`Total: ${listRecibos.payments.length}`}
                    width="43%"
                  />
                  <PDFTableRow
                    textAlign="right"
                    title={`R$ ${FormatMoney(
                      listRecibos.payments
                        .filter((item) => item.resume.totalAReceber > 0)
                        .reduce(
                          (acc, item) => acc + item.resume.totalAReceber,
                          0
                        )
                        ?.toFixed(2)
                    )}`}
                    width="12%"
                  />
                  <PDFTableRow
                    textAlign="right"
                    title={`R$ ${
                      listRecibos.payments.some(
                        (item) => item.resume.totalAReceber < 0
                      )
                        ? "-"
                        : ""
                    }${FormatMoney(
                      listRecibos.payments
                        .filter((item) => item.resume.totalAReceber < 0)
                        .reduce(
                          (acc, item) =>
                            acc + Number(item.resume.totalAReceber?.toFixed(2)),
                          0
                        )
                        ?.toFixed(2)
                    )}`}
                    paddingRight="8px"
                    width="15%"
                  />
                  <PDFTableRow
                    paddingRight="8px"
                    textAlign="right"
                    title=""
                    width="30%"
                  />
                </TableRowContainer>
              </TableBase>
            </PageCorePDF>
          </Document>
        </PDFViewer>
      )}

      {isLoading && (
        <Box style={{ width: "100%" }}>
          <LinearProgress color="inherit" />
        </Box>
      )}
    </>
  );
};
